import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { buttonVariants } from '../common/buttons/types';
import MainButton from '../common/buttons/MainButton';
import styles from './Faq.module.scss';
import { FaqTypes } from '../../utils/constants';
import colors from '../../scss/colors';

export function Faq({ selectedData = [], onSelect }) {
  const [activeFaq, setActiveFaq] = useState(FaqTypes.ACCOUNTS);
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const { t } = useTranslation();

  const handleFaqTypeClick = (type) => {
    onSelect(type);
    setActiveFaq(type);
    setExpandedAccordion(null);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : null);
  };

  return (
    <div className={styles.faqContainer}>
      <div className={styles.faqWrapper}>
        <h2>{t('landingPages.faq.title')}</h2>
        <div className={styles.buttonContainer}>
          <MainButton
            variant={activeFaq === FaqTypes.ACCOUNTS ? buttonVariants.LIGHT_BLUE : buttonVariants.TEXT}
            rounded
            size="xmedium"
            action={() => handleFaqTypeClick(FaqTypes.ACCOUNTS)}
            sx={{
              textShadow: activeFaq === FaqTypes.ACCOUNTS ? '0 1px 2px rgba(0, 0, 0, 0.4)' : 'none'
            }}
          >
            {t('landingPages.faq.category1')}
          </MainButton>
          <MainButton
            variant={activeFaq === FaqTypes.JOBS ? buttonVariants.LIGHT_BLUE : buttonVariants.TEXT}
            rounded
            size="xmedium"
            action={() => handleFaqTypeClick(FaqTypes.JOBS)}
            sx={{
              textShadow: activeFaq === FaqTypes.JOBS ? '0 1px 2px rgba(0, 0, 0, 0.4)' : 'none'
            }}
          >
            {t('landingPages.faq.category2')}
          </MainButton>
          <MainButton
            variant={activeFaq === FaqTypes.OTHERS ? buttonVariants.LIGHT_BLUE : buttonVariants.TEXT}
            rounded
            size="xmedium"
            action={() => handleFaqTypeClick(FaqTypes.OTHERS)}
            sx={{
              textShadow: activeFaq === FaqTypes.OTHERS ? '0 1px 2px rgba(0, 0, 0, 0.4)' : 'none'
            }}
          >
            {t('landingPages.faq.category3')}
          </MainButton>
        </div>
        <div className={styles.dataContainer}>
          {selectedData.map((data, index) => (
            <Accordion
              // eslint-disable-next-line react/no-array-index-key -- static FAQ list, never reordered
              key={index}
              expanded={expandedAccordion === index}
              onChange={handleAccordionChange(index)}
              sx={{
                boxShadow: 'none',
                padding: 0,
                '& .MuiAccordionSummary-root .MuiTypography-root': {
                  fontSize: '22px',
                  padding: '15px 0px',
                  color: colors.DARK_BLUE,
                  fontWeight: 500
                },
                '& .MuiAccordionSummary-root .Mui-expanded': {
                  margin: '0'
                },
                '& .MuiCollapse-vertical .MuiTypography-root': {
                  fontWeight: 300
                }
              }}
            >
              <AccordionSummary expandIcon={<ArrowDropDownIcon />} aria-controls="panel1-content" id="panel1-header">
                <Typography component="span">{data.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {/* eslint-disable-next-line react/no-danger -- trusted HTML from static i18n faqContent */}
                  <span dangerouslySetInnerHTML={{ __html: data.answer }} />
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
    </div>
  );
}
